import React, { useState } from 'react';
import { 
  FaSearch, 
  FaExchangeAlt, 
  FaChevronDown, 
  FaChevronUp,
  FaCog
} from 'react-icons/fa';

function FindReplace({ quill }) {
  const [findText, setFindText] = useState('');
  const [replaceText, setReplaceText] = useState('');
  const [caseSensitive, setCaseSensitive] = useState(false);
  const [wholeWord, setWholeWord] = useState(false);
  const [showReplace, setShowReplace] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  const find = () => {
    if (!quill) return;
    const text = quill.getText();
    let searchText = findText;
    let flags = 'g';
    if (!caseSensitive) {
      searchText = searchText.toLowerCase();
      flags += 'i';
    }
    if (wholeWord) {
      searchText = `\\b${searchText}\\b`;
    }
    const regex = new RegExp(searchText, flags);
    const matches = [];
    let match;
    while ((match = regex.exec(caseSensitive ? text : text.toLowerCase())) !== null) {
      matches.push(match.index);
    }
    if (matches.length > 0) {
      const index = matches[0];
      quill.setSelection(index, findText.length);
    } else {
      alert('Text not found');
    }
  };

  const replace = () => {
    if (!quill) return;
    const range = quill.getSelection();
    if (range) {
      const formats = quill.getFormat(range);
      quill.deleteText(range.index, range.length);
      quill.insertText(range.index, replaceText, formats);
      quill.setSelection(range.index + replaceText.length, 0);
    }
  };

  const replaceAll = () => {
    if (!quill) return;
    const text = quill.getText();
    let searchText = findText;
    let flags = 'g';
    if (!caseSensitive) {
      searchText = searchText.toLowerCase();
      flags += 'i';
    }
    if (wholeWord) {
      searchText = `\\b${searchText}\\b`;
    }
    const regex = new RegExp(searchText, flags);
    let match;
    let lastIndex = 0;
    while ((match = regex.exec(caseSensitive ? text : text.toLowerCase())) !== null) {
      const range = { index: match.index, length: match[0].length };
      const formats = quill.getFormat(range);
      quill.deleteText(range.index, range.length);
      quill.insertText(range.index, replaceText, formats);
      lastIndex = range.index + replaceText.length;
      regex.lastIndex = lastIndex;
    }
  };

  return (
    <div className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200 shadow-sm">
      <div className="p-4 space-y-4">
        <div className="flex items-center bg-white rounded-md border border-gray-300 shadow-sm">
          <FaSearch className="text-gray-400 ml-3" />
          <input
            type="text"
            placeholder="Find"
            value={findText}
            onChange={(e) => setFindText(e.target.value)}
            className="flex-grow p-2 bg-transparent focus:outline-none"
          />
          <button 
            onClick={() => setShowReplace(!showReplace)} 
            className="p-2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            {showReplace ? <FaChevronUp /> : <FaChevronDown />}
          </button>
        </div>
        
        {showReplace && (
          <div className="flex items-center bg-white rounded-md border border-gray-300 shadow-sm">
            <FaExchangeAlt className="text-gray-400 ml-3" />
            <input
              type="text"
              placeholder="Replace"
              value={replaceText}
              onChange={(e) => setReplaceText(e.target.value)}
              className="flex-grow p-2 bg-transparent focus:outline-none"
            />
          </div>
        )}
        
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-2 sm:space-y-0">
          <button 
            onClick={() => setShowOptions(!showOptions)}
            className="text-sm text-gray-600 hover:text-gray-800 flex items-center focus:outline-none"
          >
            <FaCog className="mr-1" />
            Options
          </button>
          <div className="flex flex-wrap gap-2 w-full sm:w-auto justify-end">
            <button onClick={find} className="px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm rounded-md hover:from-blue-600 hover:to-blue-700 transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">
              Find
            </button>
            {showReplace && (
              <>
                <button onClick={replace} className="px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white text-sm rounded-md hover:from-green-600 hover:to-green-700 transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50">
                  Replace
                </button>
                <button onClick={replaceAll} className="px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 text-white text-sm rounded-md hover:from-red-600 hover:to-red-700 transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
                  Replace All
                </button>
              </>
            )}
          </div>
        </div>
        
        {showOptions && (
          <div className="bg-white p-3 rounded-md border border-gray-200 space-y-2 shadow-sm">
            <label className="flex items-center text-sm text-gray-700">
              <input
                type="checkbox"
                checked={caseSensitive}
                onChange={(e) => setCaseSensitive(e.target.checked)}
                className="mr-2 focus:ring-2 focus:ring-blue-500"
              />
              Match case
            </label>
            <label className="flex items-center text-sm text-gray-700">
              <input
                type="checkbox"
                checked={wholeWord}
                onChange={(e) => setWholeWord(e.target.checked)}
                className="mr-2 focus:ring-2 focus:ring-blue-500"
              />
              Whole words
            </label>
          </div>
        )}
      </div>
    </div>
  );
}

export default FindReplace;